import CreditCardInfo from './CreditCardInfo';

export default CreditCardInfo;
